import { useQuery } from "@tanstack/react-query";

import { workspaceApi } from "pages/app/workspace/services";
import { useAuth } from "context/auth-context";
import { getPortalSectionFromSlug, PortalSection } from "utils/portal-access";

export const useWorkspaceProfile = (sectionSlug: string) => {
  const { portalAccess } = useAuth();
  const section = getPortalSectionFromSlug(sectionSlug) as PortalSection | null;

  const profileQuery = useQuery({
    queryKey: ["profile"],
    queryFn: workspaceApi.currentUser,
  });

  const currentUser = profileQuery.data;
  const effectivePortalAccess = currentUser?.portal_access || portalAccess;

  return {
    currentUser,
    effectivePortalAccess,
    isLoading: profileQuery.isLoading,
    route: `/workspace/${sectionSlug}`,
    section,
  };
};
